import { ANIMATION_IDENTIFIERS } from '@Animation/types'
import { PLUS_3_TEXTURE_KEYS } from './constants'

export const getPlus3AssetPreloader = (identifier: ANIMATION_IDENTIFIERS) => {
  const prefix = `/add-ons/extra-draw/plus-three/`

  let animationName = ''
  switch (identifier) {
    case ANIMATION_IDENTIFIERS.LIGHT_THREE:
      animationName = 'light-three'
      break
    case ANIMATION_IDENTIFIERS.NEON_LIGHTS:
      animationName = 'neon-lights'
      break
    case ANIMATION_IDENTIFIERS.PLINKO:
      animationName = 'plinko'
      break
    case ANIMATION_IDENTIFIERS.RED_BALL:
      animationName = 'red-ball'
      break
    case ANIMATION_IDENTIFIERS.SPACE_INVADERS:
      animationName = 'space-invaders'
      break
    default:
      animationName = 'default'
      break
  }

  return (scene: Phaser.Scene) => {
    if (!scene.textures.getTextureKeys().includes(PLUS_3_TEXTURE_KEYS.STANDARD_ATLAS)) {
      scene.load.atlas(
        PLUS_3_TEXTURE_KEYS.STANDARD_ATLAS,
        `${prefix}animation-plus-3-images-0.png`,
        `${prefix}animation-plus-3-images.json`,
      )
    }

    if (
      !scene.textures
        .getTextureKeys()
        .includes(`${PLUS_3_TEXTURE_KEYS.ANIMATION_ATLAS}${identifier}`)
    ) {
      scene.load.atlas(
        `${PLUS_3_TEXTURE_KEYS.ANIMATION_ATLAS}${identifier}`,
        `${prefix}animation-plus-3-${animationName}-theme-images-0.png`,
        `${prefix}animation-plus-3-${animationName}-theme-images.json`,
      )
    }
  }
}
